import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import PackagesService from "../../../../services/PackagesService";

const Packages = () => {
	const [admins, setAdmins] = useState(null);
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const packagesService = new PackagesService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const search = useSelector((state) => state.auth.search);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].packages}
						</span>
					</div>
					<div className="add-admin">
						{isExist("add_packages") && (
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									navigate("/add-package");
								}}>
								<i
									className={`la la-plus ${
										lang === "en" ? "mr-2" : "ml-2"
									}`}></i>
								{Translate[lang]?.add} {Translate[lang]?.package}
							</Button>
						)}
					</div>
				</div>
			</div>

			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.package_name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.has_price}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.price}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.status}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{admins?.length > 0 &&
									admins?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setAdmins}
						service={packagesService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
					/>
				</div>
			</div>
		</div>
	);
};
export default Packages;
